var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundPromoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 544,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M-21.358-14.415H1457.96v577.453H-21.358V-14.415Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M233.058 557.518c.007-.007 9.26-61.128 69.073-74.562 96.209-21.608 149.951 71.927 149.966 71.934m-367.596-3.214c.018-.02 11.323-156.715 179.34-198.881 203.68-51.116 309.33 120.523 309.361 120.535 0 .003 9.242 13.395 6.318 28.475-3.044 15.703-21.614 25.012-21.757 25.139-.188.166-36.424 24.176-36.428 24.178M875.489 556.136c-.002-.005-12.325-18.248-24.146-44.115-13.797-30.189-20.359-55.043-20.361-55.049 0-.002-2.957-9.73.892-20.413 3.234-8.978 10.215-13.799 10.216-13.801.002-.001 12.958-8.657 20.12-13.269 18.303-11.787 52.207-32.67 52.213-32.673.002 0 11.673-7.042 26.338-1.23 14.485 5.741 18.138 18.685 18.14 18.686.006.011 17.57 61.778 53.712 102.161 35.659 39.844 88.58 61.211 88.589 61.218M885.178-24.167c4.939-5.622-29.859 70.637 57.104 167.545 106.962 119.195 356.568 125.17 342.337 288.993-7.988 91.953-120.015 133.101-120.027 133.115"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M1045.34-52.328c2.938.027-21.835 20.254-3.13 58.385l-1.195.583c-18.832-38.853 6.396-59.95 4.907-57.772l-.582-1.196ZM1042.21 6.057c76.222 156.764 350.903 121.369 393.586 364.129l-1.369.239c-42.074-241.835-316.43-206.347-393.412-363.785l1.195-.583Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#818181",
    strokeLinejoin: "round",
    d: "m1042.21 6.057-1.195.583"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M1435.796 370.186c19.252 110.38-47.387 212.311-47.304 212.124l-1.238-.279c.092-.229 66.437-101.768 47.173-211.606l1.369-.239Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#818181",
    strokeLinejoin: "round",
    d: "m1435.796 370.186-1.369.239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPromoLight);
export default __webpack_public_path__ + "static/media/background_promo_light.916ccd506a56f720aea373ba347ff699.svg";
export { ForwardRef as ReactComponent };